// extracted by mini-css-extract-plugin
export default {"picker":"_42a3e863aa4c2eba"};